


// EarningsDashboard.jsx
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import EarningsTrendChart from "./EarningsTrendChart";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { useTranslation } from "react-i18next";

import helpers from "utils/helpers";
import { BiReset } from "react-icons/bi";
import AuthContext from "context/AuthContext";
const tabs = ["Daily", "Weekly", "Monthly", "Yearly"];
export default function EarningsDashboard() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("Daily");
  const {updatePageName } = useContext(AuthContext);
  const [service, setService] = useState()
  const [earningData, setEarningData] = useState()



  useEffect(()=>{
    updatePageName(t('EARNING_MANAGER'))
  },[])
  const getEarning = async () => {
    try {
      const resp = await apiGet(apiPath.getEarning, { serviceId: service, filterType: activeTab?.toLocaleLowerCase() })
      if (resp?.data?.success) {
        setEarningData(resp?.data?.results)
        return
      }
      setEarningData()
    } catch (err) {
      console.log('------err------', err)
    }
  }

  useEffect(() => {
    getEarning()
  }, [service, activeTab])


  const [serviceOffered, setServicesOffered] = useState([])

  const getServices = async (e) => {
    try {
      const resp = await apiGet(apiPath.getUserProfileData)
      if (resp?.data?.success) {
        setServicesOffered(resp?.data?.results?.specialtyServices)
        return
      }
      setServicesOffered([])

    } catch (err) {
      console.log('err', err)

    }
  }


  useEffect(() => {
    getServices()
  }, [])


  const handleReset = () => {
    setService('')
    setActiveTab('Daily')
  };
  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      {/* Tabs */}
      <div className="flex">
        <div className="flex gap-3 mb-6">
          {tabs?.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-md text-xs font-medium ${activeTab === tab ? "bg-gradientTo text-white" : "bg-white border text-gray-700"
                }`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div>
          <button title={t("O_RESET")} type="button" onClick={handleReset} className="bg-gradientTo text-xs px-4 py-2 flex gap-2 ml-3 mb-3 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2">
            <BiReset size={16} /> {t("O_RESET")}
          </button>
        </div>
      </div>



      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Income Breakdown */}
        <motion.div
          className="bg-white p-6 rounded-lg shadow"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">{t('INCOME_BREAKDOWN')}</h2>
            <select className="border px-2 py-1 rounded text-sm text-gray-700" value={service} onChange={(e) => { setService(e?.target?.value) }}>
              <option value={''}>{t("SELECT_SERVICE")}</option>
              {serviceOffered?.map((res) => { return (<option key={res?._id} value={res?._id}>{helpers.capitalizeFirstWord(res?.name)}</option>) })}
            </select>
          </div>

          {helpers.andOperator(earningData?.incomeBreakdown?.length>0,<div className="grid grid-cols-3 text-sm font-semibold text-gray-600 mb-2">
            <span>{t("SERVICE")}</span>
            <span>{t('EARNINGS')}</span>
            <span>{t('O_COMMISSION')}</span>
          </div>)}

          <div className="max-h-[180px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
            {earningData?.incomeBreakdown?.map((item) => (
              <div
                key={item?._id}
                className="grid grid-cols-3 items-center bg-gray-100 px-3 py-2 rounded mb-2 text-sm "
              >
                <span>{helpers.capitalizeFirstWord(item?.name)}</span>
                <span>{helpers.formattedAmount(item?.totalTransactionAmount)}</span>
                <span>{helpers.formattedAmount(item?.totalCommission)}</span>
              </div>
            ))}


            {helpers.andOperator(earningData?.incomeBreakdown?.length == 0, <div className="flex justify-center items-center text-sm h-40">
              {t('O_NO_RECORD_FOUND')}
            </div>)}
          </div>
          {helpers.andOperator(earningData?.incomeBreakdown?.length > 0, <div className="grid grid-cols-3 items-center bg-indigo-50 px-3 py-2 rounded text-sm font-semibold mt-4">
            <span>{t('TOTAL_EARNINGS')}</span>
            <span>{helpers.formattedAmount(earningData?.totalEarning?.transactionAmount)}</span>
            <span>{helpers.formattedAmount(earningData?.totalEarning?.commission)}</span>

          </div>)}
        </motion.div>

        {/* Tips Overview */}
        <motion.div
          className="bg-white p-6 rounded-lg shadow"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          <h2 className="text-lg font-semibold mb-4">{t('TIP_OVERVIEW')}</h2>
          <div className="max-h-[180px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
            {earningData?.driverDetails?.map((tip) => (
              <div
                key={tip?._id}
                className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded mb-2 text-sm"
              >
                <span>{helpers.capitalizeFirstWord(tip?.fullName)}</span>
                <span>{helpers.formattedAmount(tip?.totalTransactionAmount)}</span>
              </div>
            ))}

            {helpers.andOperator(earningData?.driverDetails?.length == 0, <div className="flex justify-center items-center text-sm h-40">
              {t('O_NO_RECORD_FOUND')}
            </div>)}

          </div>

          {helpers.andOperator(earningData?.driverDetails?.length>0,<div className="flex justify-between items-center bg-indigo-50 px-3 py-2 rounded text-sm font-semibold mt-4">
            <span>{t('TOTAL_TIP')}</span>
            <span>{helpers.formattedAmount(earningData?.totalAllDriversTip || 0)}</span>
          </div>)}
        </motion.div>

      </div>

      <EarningsTrendChart graphData={earningData?.graphData} />

    </div>
  );
}
